<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/dinventory/index">Manage Inventory</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Bin Card
      </h6>

      <div class="container-fluid">
        <div v-if="isLoading" class="card bdr-rad2 shadow p-4 text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div v-else-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <template v-else>
          <div class="card bdr-rad2 shadow p-2 mb-3">
            <div class="card-body">
              <table class="table table-sm table-borderless mb-0 inventory-summary">
                <tbody>
                  <tr><td><b>SKU</b></td><td>{{ inventory.SKU || '-' }}</td></tr>
                  <tr><td><b>Name</b></td><td>{{ inventory.Name || inventory.product_name || '-' }}</td></tr>
                  <tr><td><b>Store Location</b></td><td>{{ inventory.Location || inventory.StoreLocation || '-' }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card bdr-rad2 shadow p-2">
            <div class="card-body">
              <div class="section-title">Transaction</div>
              <div class="table-responsive">
                <table class="table table-sm table-hover transaction-table mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Transaction Date</th>
                      <th>Transaction No.</th>
                      <th>Received Qty</th>
                      <th>Issued Qty</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(transaction, index) in transactions" :key="transaction.id_tansaction || index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ transaction.transaction_date || transaction.created_date || '-' }}</td>
                      <td>{{ transaction.transaction_no || '-' }}</td>
                      <td>{{ quantity(transaction.received_qty) }}</td>
                      <td>{{ quantity(transaction.issues_qty) }}</td>
                      <td>{{ quantity(transaction.balance) }}</td>
                    </tr>
                    <tr v-if="transactions.length === 0">
                      <td colspan="6" class="empty-state">No transactions found for this product.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      inventory: {},
      transactions: [],
      isLoading: true,
      errorMessage: '',
    };
  },
  mounted() {
    this.loadBinCard();
  },
  methods: {
    quantity(value) {
      return value === null || value === undefined || value === '' ? 0 : Number(value);
    },
    async loadBinCard() {
      const id = this.$route.query.id;

      if (!id) {
        this.errorMessage = 'Inventory ID is missing.';
        this.isLoading = false;
        return;
      }

      try {
        const { data } = await axios.get('/dinventory/bin-card', {
          params: { id },
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });

        this.inventory = data.inventory || {};
        this.transactions = Array.isArray(data.transactions) ? data.transactions : [];
      } catch (error) {
        this.errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Unable to load the bin card.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.bdr-rad2 {
  border-radius: 15px;
}

.inventory-summary td:first-child {
  width: 250px;
}

.section-title {
  padding: 4px 8px;
  margin-bottom: 8px;
  border-radius: 3px;
  background: #0d6efd;
  color: white;
  font-weight: 600;
}

.transaction-table thead {
  background: #245780;
  color: white;
}

.transaction-table th,
.transaction-table td {
  white-space: nowrap;
  vertical-align: middle;
}

.empty-state {
  padding: 28px !important;
  color: #687b91;
  text-align: center;
}

@media (max-width: 576px) {
  .inventory-summary td:first-child {
    width: 135px;
  }

  .transaction-table {
    font-size: 12px;
  }
}
</style>
